/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetPlatformUsageQueryResponse, GetPlatformUsagePathParams, GetPlatformUsage400, GetPlatformUsage401, GetPlatformUsage403, GetPlatformUsage404, GetPlatformUsage409, GetPlatformUsage500 } from "../../types/platformBillingController/GetPlatformUsage.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetPlatformUsageUrl(organizationId: GetPlatformUsagePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/platform-billing/usage` as const }
  return res
}

/**
 * @summary Get usage for tracked features
 * {@link /api/organizations/:organizationId/platform-billing/usage}
 */
export async function getPlatformUsage(organizationId: GetPlatformUsagePathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetPlatformUsageQueryResponse, ResponseErrorConfig<GetPlatformUsage400 | GetPlatformUsage401 | GetPlatformUsage403 | GetPlatformUsage404 | GetPlatformUsage409 | GetPlatformUsage500>, unknown>({ method : "GET", url : getGetPlatformUsageUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}